import { defaultFlareProviderConfiguration } from '../../default-constants';

export const SPARK_DEX_FLARE_CONTRACT_ADDRESS = '0x4a1E5A90e9943467FAd1acea1E7F0e5e88472a1e';

export const SPARK_DEX_FLARE_PROVIDER_CONFIGURATION = defaultFlareProviderConfiguration;
